import { useState } from "react";

// Таван на количеството в един ред — предпазва от случайно „999.999"
// (потвърдено продуктово решение: 0 до 200).
const MAX_QUANTITY = 200;

/**
 * Състоянието на голямото поле за количество в модалите „Промени"
 * (ModifyItemModal) и молива (EditModifiersModal): числото + суровият текст
 * в полето (за да може да се пише „0.", „,5" и т.н.).
 */
export const useQuantityInput = () => {
  const [quantity, setQuantityValue] = useState(1);
  const [quantityInput, setQuantityInput] = useState("1");

  const setQuantity = (value: number) => {
    setQuantityValue(value);
    setQuantityInput(String(value));
  };

  const handleQuantityInputChange = (value: string) => {
    // Запетаята е равностойна на точка (кирилска клавиатура/навик от касата),
    // а водеща точка получава нула отпред — „,5"/„.5" → „0.5", „.543" → „0.543".
    let normalized = value.replace(",", ".");
    if (normalized.startsWith(".")) normalized = "0" + normalized;
    const parsed = parseFloat(normalized);
    if (!isNaN(parsed) && parsed > MAX_QUANTITY) {
      setQuantity(MAX_QUANTITY);
      return;
    }
    setQuantityInput(normalized);
    if (!isNaN(parsed) && parsed >= 0) setQuantityValue(parsed);
  };

  const decrement = () => setQuantity(Math.max(1, quantity - 1));
  const increment = () => setQuantity(Math.min(MAX_QUANTITY, quantity + 1));

  return {
    quantity,
    quantityInput,
    setQuantity,
    handleQuantityInputChange,
    decrement,
    increment,
  };
};
